import React, { useEffect, useState } from "react";
import { ThirdWorkTreeAPI } from "../services/api";

interface WorkGroupItem {
  workGroupNo: number;
  workGroupName: string;
  workGroupDesc?: string;
  projectNo?: number;
  wbs?: number;
}
interface WorkItem {
  workNo: number;
  work: string;
  workGroup: number;
}


/* interface Props {
  wbsId: number | null;
    notationNo?: number | null;
   onWorkSelect?: (workNo: number) => void;
   onWorkGroupSelect?: (
    workGroupNo: number | null
  ) => void;

} */
interface Props {
  wbsId: number | null;
  notationNo?: number | null;

  onWorkSelect?: (
    workNo: number | null
  ) => void;

  onWorkGroupSelect?: (
    workGroupNo: number | null
  ) => void;
}


//const WorkTreePanel: React.FC<Props> = ({ wbsId }) => {
const WorkTreePanel: React.FC<Props> = ({
  wbsId,
   notationNo,
  onWorkSelect,
  onWorkGroupSelect,
}) => {
  const [data, setData] = useState<WorkGroupItem[]>([]);
  const [loading, setLoading] = useState(false);

  const [expanded, setExpanded] = useState<number[]>([]);
  const [works, setWorks] = useState<Record<number, WorkItem[]>>({});

  const [selectedWorkGroup, setSelectedWorkGroup] = useState<number | null>(() => {
  const saved = sessionStorage.getItem("WorkGroup_SelectedNo");
  return saved ? Number(saved) : null;
});

const [selectedWork, setSelectedWork] = useState<number | null>(() => {
  const saved = sessionStorage.getItem("Work_SelectedNo");
  return saved ? Number(saved) : null;
});
 
  useEffect(() => {
  console.log("WBS =", wbsId);
  console.log("Notation =", notationNo);
}, [wbsId, notationNo]);

 /*   const toggleWorkGroup = async (
    workGroupNo: number
  ) => { */
   const toggleWorkGroup = async (
  workGroupNo: number,
  restoreWorkNo?: number,
  isRestore: boolean = false
) => {
  if (!isRestore) {
    const isExpanded =
      expanded.includes(workGroupNo);

    if (isExpanded) {
      /* setExpanded(prev =>
        prev.filter(x => x !== workGroupNo)
      ); */
      setExpanded(prev => {
  const updated = prev.filter(
    x => x !== workGroupNo
  );

  sessionStorage.setItem(
    "WorkGroup_Expanded",
    JSON.stringify(updated)
  );

  return updated;
});
      return;
    }
  }

    try {
      /* if (!works[workGroupNo]) {
        const data =
          await ThirdWorkTreeAPI.getWorks(
            workGroupNo
          );

        setWorks(prev => ({
          ...prev,
          [workGroupNo]: data,
        }));
      }
 */

      if (!works[workGroupNo]) {

  let data;

  if (notationNo) {
    data =
      await ThirdWorkTreeAPI.getWorksByNotation(
        workGroupNo,
        notationNo
      );
  } else {
    data =
      await ThirdWorkTreeAPI.getWorks(
        workGroupNo
      );
  }

  setWorks(prev => ({
    ...prev,
    [workGroupNo]: data,
  }));
}
if (restoreWorkNo) {
  setSelectedWork(restoreWorkNo);
  onWorkSelect?.(restoreWorkNo);
}
      /* setExpanded(prev => [
        ...prev,
        workGroupNo,
      ]); */
      setExpanded(prev => {
  const updated = [...prev, workGroupNo];

  sessionStorage.setItem(
    "WorkGroup_Expanded",
    JSON.stringify(updated)
  );

  return updated;
});

    } catch (err) {
      console.error(err);
    }
  };

  

/* useEffect(() => {
    if (!wbsId) {
      setData([]);
      return;
    }

    setLoading(true);

    ThirdWorkTreeAPI.getWorkTree(wbsId)
      .then(setData)
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [wbsId]); */

  useEffect(() => {
    setWorks({});
setExpanded([]);
  setLoading(true);

  console.log("WBS =", wbsId);
  console.log("Notation =", notationNo);

 /*  if (notationNo) {
    ThirdWorkTreeAPI.getWorkGroupsByNotation(notationNo)
      .then(setData)
      .catch(console.error)
      .finally(() => setLoading(false));

    return;
  } */
 if (notationNo) {
  ThirdWorkTreeAPI.getWorkGroupsByNotation(notationNo)
    .then(async (groups) => {
      setData(groups);

      //const savedGroup = sessionStorage.getItem("WorkGroup_SelectedNo");
     /*  const savedWork = sessionStorage.getItem("Work_SelectedNo");

      if (savedGroup) {
        const workGroupNo = Number(savedGroup);

        setSelectedWorkGroup(workGroupNo);
        onWorkGroupSelect?.(workGroupNo);

        await toggleWorkGroup(
          workGroupNo,
          savedWork ? Number(savedWork) : undefined,
          true
        );
      } */
     const savedExpanded = sessionStorage.getItem(
  "WorkGroup_Expanded"
);

const savedGroup = sessionStorage.getItem(
  "WorkGroup_SelectedNo"
);

const savedWork = sessionStorage.getItem(
  "Work_SelectedNo"
);

if (savedExpanded) {

  const expandedGroups: number[] =
    JSON.parse(savedExpanded);

  for (const workGroupNo of expandedGroups) {

    await toggleWorkGroup(
      workGroupNo,
      savedGroup &&
      Number(savedGroup) === workGroupNo &&
      savedWork
        ? Number(savedWork)
        : undefined,
      true
    );

  }

  if (savedGroup) {
    setSelectedWorkGroup(Number(savedGroup));
    onWorkGroupSelect?.(Number(savedGroup));
  }
}

    })
    .catch(console.error)
    .finally(() => setLoading(false));

  return;
}

  if (wbsId) {
    /* ThirdWorkTreeAPI.getWorkTree(wbsId)
      .then(setData)
      .catch(console.error)
      .finally(() => setLoading(false)); */
      ThirdWorkTreeAPI.getWorkTree(wbsId)
  .then(async (groups) => {
    setData(groups);

    /* const savedGroup = sessionStorage.getItem("WorkGroup_SelectedNo");
    const savedWork = sessionStorage.getItem("Work_SelectedNo");

    if (savedGroup) {
      const workGroupNo = Number(savedGroup);

      setSelectedWorkGroup(workGroupNo);
      onWorkGroupSelect?.(workGroupNo);

      await toggleWorkGroup(
        workGroupNo,
        savedWork ? Number(savedWork) : undefined,
          true
      );
    } */
   const savedExpanded = sessionStorage.getItem(
  "WorkGroup_Expanded"
);

const savedGroup = sessionStorage.getItem(
  "WorkGroup_SelectedNo"
);

const savedWork = sessionStorage.getItem(
  "Work_SelectedNo"
);

if (savedExpanded) {

  const expandedGroups: number[] =
    JSON.parse(savedExpanded);

  for (const workGroupNo of expandedGroups) {

    await toggleWorkGroup(
      workGroupNo,
      savedGroup &&
      Number(savedGroup) === workGroupNo &&
      savedWork
        ? Number(savedWork)
        : undefined,
      true
    );

  }

  if (savedGroup) {
    setSelectedWorkGroup(Number(savedGroup));
    onWorkGroupSelect?.(Number(savedGroup));
  }
}

  })
  .catch(console.error)
  .finally(() => setLoading(false));

    return;
  }

  setData([]);
  setLoading(false);
}, [wbsId, notationNo]);

 // if (!wbsId) {
    if (!wbsId && !notationNo) {
    return (
      <div className="p-4 text-gray-500">
        Select a WBS or notation node
      </div>
    );
  }

  if (loading) {
    return (
      <div className="p-4">
        Loading...
      </div>
    );
  }

  return (
    <div
      className="h-full overflow-auto thin-scrollbar"
      style={{
        fontFamily: "'Segoe UI', sans-serif",
        fontSize: "13px",
        fontWeight: 400,
      }}
    >
      {data.length === 0 ? (
        <div className="p-4 text-gray-500">
          No Work Groups found
        </div>
      ) : (
        /* data.map((item) => (
          <div
            key={item.workGroupNo}
            className="px-3 py-2 border-b hover:bg-indigo-50 cursor-pointer"
          >
            <div className="text-gray-800">
              {item.workGroupName}
            </div>
          </div>

        )) */
       data.map((item) => (
  <React.Fragment
    key={item.workGroupNo}
  >
    <div
      //className="px-3 py-2 border-b hover:bg-indigo-50 cursor-pointer flex items-center gap-2"
      className={`px-3 py-2 border-b cursor-pointer flex items-center gap-2 ${
  selectedWorkGroup === item.workGroupNo
    ? "bg-indigo-100 text-indigo-700"
    : "hover:bg-indigo-50"
}`}
      /*  onClick={() =>
        toggleWorkGroup(
          item.workGroupNo
        )  */
         /*  onClick={() => {
  onWorkGroupSelect?.(
    item.workGroupNo
  );

  onWorkSelect?.(null);

  toggleWorkGroup(
    item.workGroupNo
  );
}}
       */ 
      onClick={() => {
  setSelectedWorkGroup(item.workGroupNo);

  sessionStorage.setItem(
    "WorkGroup_SelectedNo",
    item.workGroupNo.toString()
  );

  onWorkGroupSelect?.(item.workGroupNo);

  setSelectedWork(null);
sessionStorage.removeItem("Work_SelectedNo");
  onWorkSelect?.(null);

  toggleWorkGroup(item.workGroupNo);
}}
      
    >
      <span
        style={{
          width: 14,
          height: 14,
          border: "1px solid #999",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "10px",
          background: "#fff",
          flexShrink: 0,
        }}
      >
        {expanded.includes(
          item.workGroupNo
        )
          ? "−"
          : "+"}
      </span>

      <span className="text-gray-800">
        {item.workGroupName}
      </span>
    </div>

    {expanded.includes(
      item.workGroupNo
    ) &&
      /* works[
        item.workGroupNo
      ]?.map(work => (
        <div
          key={work.workNo}
          className="pl-8 py-1 text-sm text-gray-700 hover:bg-gray-50"
        >
          {work.work}
        </div>
      )) */

        works[item.workGroupNo]?.map(work => (
  <div
    key={work.workNo}
   // className="pl-8 py-1 text-sm text-gray-700 hover:bg-blue-50 cursor-pointer"
   className={`pl-8 py-1 text-sm cursor-pointer ${
  selectedWork === work.workNo
    ? "bg-indigo-100 text-indigo-700"
    : "text-gray-700 hover:bg-blue-50"
}`}
   // onClick={() => onWorkSelect?.(work.workNo)}
   onClick={() => {
  setSelectedWork(work.workNo);

  sessionStorage.setItem(
    "Work_SelectedNo",
    work.workNo.toString()
  );

  onWorkSelect?.(work.workNo);
}}
  >
    {work.work}
  </div>
))
      }
  </React.Fragment>
))

      )}
    </div>
  );
};

export default WorkTreePanel;